export default "__VITE_ASSET__CTKf12Tb__"